import { PrevNextButtons } from '@app/core/components/PrevNextButtons';
import { HotkeyDisplay } from '@app/core/hotkeys/HotkeyDisplay';
import { Box, Typography } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { VerifyMatchDialogNavigationState } from './verify-match-types';

const previousMessage = defineMessage({
  id: 'audit.verifyMatch.previous',
  defaultMessage: 'Anterior',
});

const nextMessage = defineMessage({
  id: 'audit.verifyMatch.next',
  defaultMessage: 'Siguiente',
});

const positionMessage = defineMessage({
  id: 'audit.verifyMatch.navigationPosition',
  defaultMessage: '{current} / {total}',
});

export interface VerifyMatchDialogNavigationProps {
  navigation: VerifyMatchDialogNavigationState;
}

/**
 * Prev/next controls and position label for walking list rows from the dialog.
 * Tooltips include ArrowLeft / ArrowRight shortcuts via HotkeyDisplay.
 */
export function VerifyMatchDialogNavigation({ navigation }: VerifyMatchDialogNavigationProps) {
  const { $t } = useIntl();
  const { onPrev, onNext, hasPrev, hasNext, current, total } = navigation;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap', mr: 0.5 }}>
        {$t(positionMessage, { current, total })}
      </Typography>
      <PrevNextButtons
        onPrev={onPrev}
        onNext={onNext}
        hasPrev={hasPrev}
        hasNext={hasNext}
        prevLabel={
          <>
            {$t(previousMessage)} &nbsp; <HotkeyDisplay hotkey="arrowleft" />
          </>
        }
        nextLabel={
          <>
            {$t(nextMessage)} &nbsp; <HotkeyDisplay hotkey="arrowright" />
          </>
        }
      />
    </Box>
  );
}
